


















import Vue from 'vue'
import CardForm from './CardForm.vue'
import {AppCardServiceProxy} from '@/service-proxies/app-v2/system.service-proxies'

const appCardServiceProxy = new AppCardServiceProxy()

export default Vue.extend({
  name: 'AddMenu',
  components: {
    CardForm
  },
  props: {
    visible: { // 是否展示
      type: Boolean,
      default: false
    },
    appInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    clientList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    'appId'() {
      const {appInfo}: any = this
      return appInfo && appInfo.id
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        // 关闭弹框后清空数据

      }
    }
  },
  methods: {
    async handleOk() {
      const {handleValidate} = this.$refs.cardForm
      let validateStatus = true
      await handleValidate().then((res: any) => {
        validateStatus = res
      })
      // console.log('validateStatus:', validateStatus)
      if (!validateStatus) {
        return
      }
      this.loading = true
      const {formData}: any = this.$refs.cardForm
      // 新增卡片
      let params = {
        appId: this.appId,
        ...formData
      }
      appCardServiceProxy.insertAppCard(params).then((res: any) => {
        // console.log('add,', res)
        if (res) {
          this.$message.success('新建成功！')
          this.$emit('close', true)
        }
      }).finally(()=>{
        this.loading = false
      })

    },
    handleCancel() {
      this.$emit('close')
    }
  }
})
